@import "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap";

/* src/app/common/components/header-top/header-top.component.scss */
.top-header {
  background: var(--bg-light-pink);
  z-index: 1024;
  color: white;
}
.top-header .minwidth-drop {
  min-width: 76px;
}
.logo-left span {
  font-size: 14px;
  line-height: 1;
  font-family: "Noto Sans Bold";
  color: var(--color-black);
}
.logo-left img {
  width: 42px;
}
.logo-tradder {
  flex: 1;
}
@media screen and (max-width: 1350px) {
  .logo-tradder {
    flex: auto;
  }
}
.right-end-content {
  width: 580px;
  justify-content: end;
}
@media screen and (max-width: 767px) {
  .right-end-content {
    justify-content: center !important;
  }
}
.language-bg {
  padding-left: 35px;
  background-image: url("./media/language-translate-P6PFNTM2.svg");
  background-size: 20px;
  background-position: 5px center;
  color: var(--color-gray21);
  background-repeat: no-repeat;
}
.skip-main-content {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-gray21);
  background-color: var(--body-background);
  border-radius: 8px;
  padding: 6px 14px;
}
.bhashini-selected-language {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 8px 12px;
  background-color: #f0f0f0;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
}
.language-display {
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgb(232, 122, 186);
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
.bhashini-dropdown {
  position: fixed;
  z-index: 1000;
}
.bhashini-dropdown-btn {
  display: flex;
  background-color: transparent;
  color: #fff;
  font-size: 16px;
  border: none;
  cursor: pointer;
  max-width: 100%;
}
.bhashini-dropdown-btn-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bhashini-dropdown-content {
  display: none;
  position: absolute;
  max-height: 25rem;
  overflow-y: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  border-radius: 0.5rem;
  width: 13rem;
  border: 1px solid var(--Grey-Grey-45, #737373);
  background: rgba(255, 255, 255, 0.96);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.bhashini-dropdown-content > div {
  color: black;
  padding: 0.62rem 1rem;
  text-decoration: none;
  display: flex;
}
.bhashini-dropdown-content div:hover {
  background-color: #f1f1f1;
}
.bhashini-dropdown-content.show {
  display: block;
  animation: fadeIn 0.3s ease forwards;
}
.bhashini-branding {
  background-color: #fff;
  color: #555;
  text-align: center;
  padding: 8px;
  font-size: 12px;
  position: sticky;
  bottom: 0;
  justify-content: end;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.625rem;
  font-weight: 600;
}
.bhashini-dropdown-btn-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  margin: auto;
}
.bhashini-dropdown-content.show-up {
  display: block;
  bottom: 100%;
}
.bhashini-dropdown-content.show-down {
  display: block;
  top: 100%;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.bhashini-feedback-div {
  margin-right: auto;
  width: max-content;
}
.bhashini-feedback-button {
  display: flex;
  gap: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
}
.bhashini-feedback-modal {
  display: none;
  position: fixed;
  z-index: 1001;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 1rem;
}
.bhashini-feedback-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.close-modal {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}
.star-rating {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 25px;
}
.star {
  font-size: 30px;
  cursor: pointer;
  color: #ccc;
  transition: color 0.3s;
}
textarea {
  width: 100%;
  height: 80px;
  margin-top: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.submit-feedback {
  margin-top: 10px;
  background-color: #2743A3;
  color: white;
  padding: 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  width: max-content;
  float: right;
}
.bhashini-feedback-star-container {
  display: flex;
  gap: 0.75rem;
  flex-direction: column;
}
.star-rating {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 25px;
}
.star {
  width: 30px;
  height: 29px;
  cursor: pointer;
  transition: fill 0.3s ease;
}
.star svg path {
  fill: #D9D9D9;
}
.star.hovered svg path,
.star.selected svg path {
  fill: #FBBC04;
}
.feedback-textarea {
  margin-top: 1.12rem;
  padding: 1rem;
}
.bhashini-feedback-heading {
  font-size: 1.12rem;
}
#suggested-feedback-checkbox {
  margin-top: 1.12rem;
}
.feedback-suggested-feedback {
  margin-top: 1.12rem;
  padding: 1rem;
}
.bhashini-plugin-container > .bhashini-dropdown {
  position: relative;
}
.bhashini-plugin-container > div:nth-child(2) {
  display: none !important;
}
@media (max-width: 768px) {
  .bhashini-dropdown-content {
    right: -100%;
  }
}
.warning-text {
  position: absolute;
  background-color: #FAE1D5;
  border-radius: 3px;
  padding: 2px 15px;
  color: #f00;
  font-weight: 700;
  font-size: 13px;
}
@media (max-width: 1023px) {
  .warning-text {
    font-size: 11px;
  }
}
@media (max-width: 767px) {
  .warning-text {
    position: relative;
    font-size: 10px;
    margin: 3px 0;
  }
}
.pulser {
  background: var(--color-primary);
  border-radius: 50%;
  position: relative;
}
.pulser::after {
  animation: pulse 3000ms cubic-bezier(0.9, 0.7, 0.5, 0.9) infinite;
}
@keyframes pulse {
  0% {
    opacity: 0;
  }
  50% {
    transform: scale(1.4);
    opacity: 0.4;
  }
}
.pulser::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--body-background);
  border-radius: 50%;
  z-index: -1;
}
.accessibility-menu {
  min-width: 140px;
  display: contents;
}
@media screen and (max-width: 460px) {
  .accessibility-menu {
    display: none;
  }
}
.accessibility-menu .accessibility-wrapper {
  background-color: var(--body-background);
  border-radius: 8px;
  height: 30px;
}
.accessibility-menu .accessibility-text {
  color: var(--color-gray21);
  font-size: 13px;
  font-weight: 500;
  padding: 0 10px;
}
.accessibility-menu button {
  font-size: 18px;
  font-weight: 600;
  background: transparent;
  line-height: 1;
}
.accessibility-menu span {
  font-size: 16px;
}
.lang-block {
  background-color: var(--body-background);
  border-radius: 8px;
  padding: 2px;
}
.theme-block {
  background-color: var(--body-background);
  border-radius: 8px;
  padding: 5px;
}
.theme-block .theme-text {
  color: var(--color-gray21);
  font-size: 13px;
  font-weight: 500;
}
@media (max-width: 767px) {
  .theme-block .theme-text {
    font-size: 12px;
  }
}
.theme-block button {
  border: none;
  border-radius: 4px;
  border: 1px solid;
}
.theme-block button.active {
  background-image: url("./media/check-icon-OGFHYNQV.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 20px;
}
.theme-block button.pink-color {
  background-color: #CA2E92;
  border-color: rgba(202, 46, 146, 0.2);
}
.theme-block button.red-color {
  background-color: #F47216;
  border-color: rgba(244, 114, 22, 0.2);
}
.theme-block button.blue-color {
  background-color: #2D8686;
  border-color: rgba(45, 134, 134, 0.2);
}
.theme-block button.green-color {
  background-color: #0000FF;
  border-color: rgba(0, 0, 255, 0.2);
}
.theme-block button.black-color {
  background-color: #000000;
  border-color: rgba(0, 0, 0, 0.2);
}
.emb-icon {
  position: absolute;
}
@media screen and (max-width: 1300px) {
  .emb-icon {
    position: relative;
  }
}
@media screen and (max-width: 1199px) {
  .container {
    padding: 0 15px !important;
  }
}
/*# sourceMappingURL=header-top.component-XRZUSSUG.css.map */
